import React from "react";
import { IconPathWithBackgroundProps } from "../../types";

export const DoubleChevronLeftRight = ({
  backgroundColor = "#fff",
  lineColor
}: IconPathWithBackgroundProps) => (
  <>
    <g id="Alternate" clipPath="url(#clip0_34418_4688)">
      <path
        d="M8.25 8.24985C8.25 8.66406 8.58579 8.99985 9 8.99985L17.5 8.99985L15.6281 10.9654C15.3424 11.2653 15.354 11.7401 15.654 12.0257L16.7401 13.0602C16.8842 13.1974 17.0768 13.2717 17.2757 13.2669C17.4746 13.262 17.6632 13.1784 17.8005 13.0343L22.0862 8.5343C22.638 7.95502 22.638 7.04478 22.0862 6.4655L17.8005 1.9655C17.6632 1.82141 17.4746 1.73781 17.2757 1.73294C17.0768 1.72807 16.8842 1.80235 16.7401 1.93957L15.654 2.97406C15.354 3.25972 15.3424 3.7345 15.6281 4.03446L17.5 5.99985L9 5.99985C8.80109 5.99985 8.61032 6.07887 8.46968 6.21951C8.32904 6.36015 8.25 6.55092 8.25 6.74985L8.25 8.24985Z"
        fill={backgroundColor}
        stroke={lineColor}
        strokeLinejoin="round"
      />
      <path
        d="M15.75 15.7501C15.75 15.5512 15.671 15.3604 15.5303 15.2198C15.3897 15.0792 15.1989 15.0001 15 15.0001L6.5 15.0001L8.37193 13.0346C8.51596 12.8974 8.59024 12.7048 8.58537 12.5059C8.58049 12.307 8.49689 12.1184 8.3528 11.9829L7.2601 10.9397C6.96013 10.6541 6.48535 10.6657 6.1997 10.9657L1.91399 15.4657C1.36223 16.045 1.36223 16.9553 1.91399 17.5346L6.1997 22.0346C6.33702 22.1787 6.5256 22.2623 6.72446 22.2671C6.92333 22.2719 7.11595 22.1976 7.2601 22.0604L8.3528 21.0171C8.65277 20.7314 8.66438 20.2567 8.37193 19.9657L6.5 18.0001L15 18.0001C15.4142 18.0001 15.75 17.6643 15.75 17.2501L15.75 15.7501Z"
        fill={backgroundColor}
        stroke={lineColor}
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_34418_4688">
        <rect width="24" height="24" fill={backgroundColor} />
      </clipPath>
    </defs>
  </>
);
